import React, { useState } from "react";
import TabbedViewWithDateSelect from "../../components/TabbedViewWithDateSelect/TabbedViewWithDateSelect";
import { JLR_PLANT } from "../../constants";
import { usePlantAndLinesStore } from "../../providers/PlantAndLinesStore/PlantAndLinesStore";
import ShiftCapacity from "../../components/ShiftCapacity/ShiftCapacity";

const ShiftCapacityConfigurator = () => {
  const [plant] = usePlantAndLinesStore().plantState;

  const [shiftCapacityCount, setShiftCapacityCount] = useState(0);

  const title = "Shift Capacity Configurator";

  return (
    <div>
      <TabbedViewWithDateSelect
        tabs={[
          {
            label: "Shift Capacity",
            title,
            count: shiftCapacityCount,
            countColor: plant.label === JLR_PLANT ? "green" : "blue",
            backgroundColor: plant.label === JLR_PLANT ? "green" : "blue",
            component: ShiftCapacity,
            props: {
              handleCountChange: setShiftCapacityCount,
            },
          },
        ]}
        pageTitle={title}
      />
    </div>
  );
};

export default ShiftCapacityConfigurator;
